import { render, staticRenderFns } from "./BaseTextField.vue?vue&type=template&id=4539c2cf&"
import script from "./BaseTextField.vue?vue&type=script&lang=js&"
export * from "./BaseTextField.vue?vue&type=script&lang=js&"
import style0 from "./BaseTextField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
